import { gql } from '@apollo/client';

const GET_CURRENT_USER = gql`
  query {
    getCurrentUser {
      id
      company
      organizationTypeId
      email
      firstname
      lastname
      jobTitle
      tel
      mobile
    }
  }
`;

const GET_USER = gql`
  query getUser($id: String!) {
    user: getUser(id: $id) {
      id
      company
      organizationTypeId
      email
      firstname
      lastname
      jobTitle
      tel
      mobile
    }
  }
`;

const GET_ORGANIZATION_TYPES = gql`
  query getOrganizationTypes {
    organizationTypes: getOrganizationTypes(sort: [{ property: "name", direction: "asc" }]) {
      id
      name
    }
  }
`;

const GET_COUNTRIES = gql`
  query getCountries {
    countries: getCountries(sort: [{ property: "name", direction: "asc" }]) {
      id
      name
      code
    }
  }
`;

const GET_COUNTIES_BY_COUNTRY_ID = gql`
  query getCounties($countryId: String!) {
    counties: getCounties(
      where: { countryId: $countryId }
      sort: [{ property: "name", direction: "asc" }]
    ) {
      id
      code
      name
      countryId
      country {
        code
        name
      }
    }
  }
`;

const GET_PAGE_WITH_BRANDS = gql`
  query getPublishedPage($id: String!) {
    pageData: getPublishedPage(id: $id) {
      __typename
      id
      name
      brandIds
    }
  }
`;

const getPageQuery = entity => {
  const capitalized = entity.charAt(0).toUpperCase() + entity.slice(1);
  return gql`
  query getRecordData($id: String!) {
    pageData: getPublished${capitalized}(id: $id) {
      __typename
      id
      name
      brandIds
      brands {
        id
        name
      }
    }
  }
`;
};

export {
  GET_USER,
  GET_ORGANIZATION_TYPES,
  GET_COUNTRIES,
  GET_COUNTIES_BY_COUNTRY_ID,
  GET_PAGE_WITH_BRANDS,
  GET_CURRENT_USER,
  getPageQuery
};
